import {
  Component,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import {
  F11Crud,
  initF11Crud,
  mapObjToCreateObj,
} from 'src/app/models/feeder11.model';
import { F33Crud, initF33SsCrud } from 'src/app/models/feeder33.model';
import { getInitRegion } from 'src/app/models/region.model';
import { PermissionsEnum } from 'src/app/models/role.model';
import {
  SubstationCrud,
  initSubstationCrud,
} from 'src/app/models/substation.model';
import { TransmissionStation } from 'src/app/models/transmission.station.model';
import { BPSAdminLevel } from 'src/app/models/user.model';
import { F11Service } from 'src/app/services/f11.service';
import { PermissionsService } from 'shared-lib';
import { RegionService } from 'src/app/services/region.service';
import { SubstationService } from 'src/app/services/substation.service';
import { TranslationService } from 'src/app/services/translation.service';
import { TsService } from 'src/app/services/ts.service';
import { TranslationUtils } from 'src/assets/i18n/translation.utils';
interface OptionObj {
  key: number;
  value: string;
}

@Component({
  selector: 'crud-f11',
  templateUrl: './crud-f11.component.html',
  styleUrls: ['./crud-f11.component.scss'],
})
export class CrudF11Component implements OnInit {
  public PermissionsEnum = PermissionsEnum;

  @Input() searchText!: string;
  @Input() utilityId: number = 0;
  @Input() bpsAdminLevel!: BPSAdminLevel;

  public currentPage: number = 1;
  public pageSize: number = 5;
  public count: number = 0;

  tss: TransmissionStation[] = [];
  feeders11: F11Crud[] = [];
  substations: SubstationCrud[] = [];
  regions: OptionObj[] = [];
  selectedSs: SubstationCrud = initSubstationCrud();
  selectedTs: TransmissionStation = new TransmissionStation();
  selectedF33Id?: number;
  selectedSsId?: number;
  selectedTsId?: number;
  selectedRegionId: number = 0;
  f33s: F33Crud[] = [];
  selectedF11: F11Crud = initF11Crud();
  actionLabel$!: Observable<string>;
  isEditMode: boolean = false;
  @ViewChild('closeAddModal') closeAddModal: ElementRef;
  @ViewChild('closeDeleteModal') closeDeleteModal: ElementRef;
  isDirectToTs: boolean | null = null;
  convertedRegions: {id: number, name: string}[] = [];

  nameplateRatingOptions = [
    '50KVA',
    '100KVA',
    '200KVA',
    '300KVA',
    '500KVA',
    '750KVA',
    '1000KVA',
    '2000KVA',
  ];

  constructor(
    private f11Service: F11Service,
    private toastr: ToastrService,
    private substationService: SubstationService,
    public permissionsService: PermissionsService,
    private regionService: RegionService,
    private translateService: TranslateService,
    private tsService: TsService
  ) {}

  ngOnInit(): void {
    if (this.utilityId != 0) {
      this.reloadTable();
    }

    this.updateActionLabel();
  }

  private updateActionLabel(): void {
    const key = this.isEditMode ? TranslationUtils.EDIT_KEY : TranslationUtils.NEW_KEY;
    this.actionLabel$ = this.translateService.stream(key);
  }

  private getRegions() {
    this.regionService.getRegionsForOptions(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
          this.convertedRegions = responseData.data.map((r: { key: any; value: any; }) => ({id: r.key, name: r.value}));
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getTss() {
    this.tsService.getAllForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.tss = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  private getSubstations() {
    this.substationService.getAllForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.substations = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  addNew() {
    this.isEditMode = false;
    this.isDirectToTs = null;

    this.selectedF11 = initF11Crud();
    this.selectedSsId = 0;
    this.selectedF33Id = -1;
    this.selectedRegionId = 0;
    this.selectedSs = initSubstationCrud();
    this.updateActionLabel();
  }

  selectF11(f11: F11Crud) {
    this.isEditMode = true;
    this.selectedF11 = { ...f11 };

    if(this.selectedF11.substation) {
      this.isDirectToTs = false;
      this.selectedSsId = this.selectedF11.substation.id;
      this.selectedSs = this.selectedF11.substation;
      this.getF33s(this.selectedSsId);
    }
    else if(this.selectedF11.transmissionStation) {
      this.isDirectToTs = true;
      this.selectedTsId = this.selectedF11.transmissionStation.id;
      this.selectedTs = this.selectedF11.transmissionStation;
    }
    this.selectedF33Id = this.selectedF11.feeder33?.id ?? -1;
    this.selectedRegionId = this.selectedF11.region?.id ?? 0;
    this.updateActionLabel();
  }

  getF33s(ssid: number) {
    this.substationService.getF33sBySSId(ssid).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.f33s = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
      this.toastr.error('Error occured');
      },
    });
  };
  

  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable(this.searchText);
  }

  reloadTable(searchText?: string, page: any = null) {
    if (page) {
      this.currentPage = page;
    }

    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        searchValue: searchText,
      },
      utilityId: this.utilityId,
    };
    this.getAllFeeders11(dataIn);
  }

  filter() {
    this.currentPage = 1;
    let dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        SearchValue: this.searchText,
      },
      utilityId: this.utilityId,
    };
    this.getAllFeeders11(dataIn);
  }

  private getAllFeeders11(dataIn: any) {
    this.f11Service.getAll(dataIn).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.feeders11 = responseData.data.data;
          this.count = responseData.data.count;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  save() {
    if (this.isDirectToTs == null) {
      this.toastr.error(this.translateService.instant('COMMON.IS_DIRECT_TO_TS_VALIDATION'));
      return;
    }

    this.selectedF11.utilityId = this.utilityId;
    var mappedF11 = mapObjToCreateObj(this.selectedF11);
    this.f11Service.save(mappedF11).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.closeAddModal?.nativeElement?.click();
          this.toastr.success(responseData?.message);
          if (this.selectedF11.id === 0) {
            this.pageChange(1);
            return;
          }
          this.reloadTable(this.searchText);
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  deleteF11() {
    this.f11Service.delete(this.selectedF11.id, this.selectedF11.name).subscribe({
      next: (response) => {
        const responseData = response.body;
        this.closeDeleteModal?.nativeElement?.click();
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.pageChange(1);
          this.toastr.success(responseData?.message);
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  onDirectToTsChange() {
    this.selectedSs = initSubstationCrud();
    this.selectedSsId = undefined;
    this.selectedTs = new TransmissionStation();
    this.selectedTsId = undefined;
    this.selectedF33Id = undefined;
    this.selectedF11.substation = undefined;
    this.selectedF11.substationId = undefined;
    this.selectedF11.transmissionStation = undefined;
    this.selectedF11.transmissionStationId = undefined;
    this.selectedF11.feeder33 = undefined;
    this.selectedF11.feeder33Id = undefined;
  }
  selectSs(ssId: number) {
    this.selectedSsId = ssId;
    this.selectedF11.substation = this.substations.find(
      (x) => x.id === this.selectedSsId
    )!;
    this.selectedSs = this.selectedF11.substation;
    this.selectedF11.substationId = this.selectedF11.substation?.id;
    this.selectedF33Id = undefined;
    this.selectedF11.feeder33 = undefined;
    this.selectedF11.feeder33Id = undefined;
    this.getF33s(this.selectedSsId);
  }


  selectF33(feederId: number) {
    if (feederId === 0 && this.selectedF33Id !== 0) {
      return;
    }
    this.selectedF33Id = feederId;
    this.selectedF11.feeder33 = this.f33s.find(
      (x) => x.id === this.selectedF33Id
    )!;
    this.selectedF11.feeder33Id = this.selectedF11.feeder33.id;
  }

  selectRegion(regionId: number) {
    this.selectedRegionId = regionId;
    if (this.selectedF11.region == undefined)
      this.selectedF11.region = getInitRegion();
    this.selectedF11.region.id = this.selectedRegionId;
  }

  selectNameplateRating(e: any) {
    this.selectedF11.nameplateRating = e.target.value;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['utilityId']) {
      if (this.utilityId != 0) {
        this.getTss();
        this.getSubstations();
        this.getRegions();
      }
    }
  }

  download(){
    const dataIn = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        searchValue: this.searchText || '',
      },
      utilityId: this.utilityId,
    };

    this.f11Service.downloadFile(dataIn).subscribe({
      next: (response) => {
        if (response?.status === 'OK' || response?.status === '200') {
          window.location.href = response.data;
        } else if (response?.status === 'Pending' || response?.status === '600') {
          this.toastr.info(response?.message || '');
        } else {
          this.toastr.error(response?.message || 'Request failed');
        }
      },
      error: (_) => {
        this.toastr.error('An error ocurred.');
        this.reloadTable(this.searchText);
      }
    });
  }

  selectTs(e: any) {
    this.selectedTsId = +e.target.value;
    this.selectedF11.transmissionStation = this.tss.find(
      (x) => x.id === this.selectedTsId
    )!;
    this.selectedF11.transmissionStationId = this.selectedF11.transmissionStation.id;
  }
}
